document.addEventListener('DOMContentLoaded', () => {
  // ReCharge renders inside a shadow root — regular querySelector can't reach it
  function queryShadowRoot(selector) {
    for (const el of document.querySelectorAll('*')) {
      if (el.shadowRoot) {
        const found = el.shadowRoot.querySelector(selector);
        if (found) return found;
      }
    }
    return null;
  }

  let rechargeWidget = queryShadowRoot('.rc-purchase-option');

  if (!rechargeWidget) {
    const rechargeObserver = new MutationObserver(() => {
      rechargeWidget = queryShadowRoot('.rc-purchase-option');
      const oneTime = queryShadowRoot('.rc-selection__onetime');
      const subAndSave = queryShadowRoot('.rc-purchase-option__subscription');

      if (rechargeWidget) {
        rechargeObserver.disconnect();
        rechargeWidget.style.background = '#F9F6F1';
        oneTime.style.borderWidth = '2px';
        subAndSave.style.borderWidth = '2px';


        oneTime.addEventListener('click', () => {
          oneTime.style.background = '#F9F6F1';
          subAndSave.style.background = '#FFFFFF';
        });

        subAndSave.addEventListener('click', () => {
          oneTime.style.background = '#FFFFFF';
          subAndSave.style.background = '#F9F6F1';
        });
      }
    });
    rechargeObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    console.log(rechargeWidget);
  }

  const observer = new MutationObserver(() => {
    if (!document.querySelector('[data-variant-picker]')) return;
    document.querySelectorAll('.selector-wrapper').forEach(wrapper => {
      wrapper.style.display = 'none';
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ReCharge benefits text override (shadow root requires a delay)
  setTimeout(() => {
    const rechargeSubscriptionWidget = document.querySelector('recharge-subscription-widget');
    if (!rechargeSubscriptionWidget) return;
    const rechargeWidgetShadow = rechargeSubscriptionWidget.shadowRoot;
    const rcBenefits = rechargeWidgetShadow.querySelector('rc-benefits');
    if (rcBenefits && rcBenefits.shadowRoot) {
      const paragraphs = rcBenefits.shadowRoot.querySelectorAll('p');
      if (paragraphs[0]) paragraphs[0].textContent = 'Save 10% & unlock free gifts starting with your first order.';
    }
  }, 500);

  // variant picker
  const variantPicker = document.querySelector('[data-variant-picker]');
  const variantSelect = document.querySelector('[data-variants]');

  if (variantPicker && variantSelect) {
    const productForm = document.querySelector('[data-product-form]');
    const productData = JSON.parse(productForm.dataset.product);
    const optionsSize = parseInt(productForm.dataset.optionsSize, 10);
    const productRoot = productForm.closest('.product-main') || document;
    const addToCartPriceEl = productRoot.querySelector('[data-add-to-cart-price]');

    function updatePriceDisplays(variant) {
      const formatted = window.Shopify.formatMoney(variant.price, productForm.dataset.moneyFormat);
      const productPriceEl = productRoot.querySelector('.productPrice');

      if (productPriceEl) {
        productPriceEl.setAttribute('aria-live', 'polite');
        let priceHtml = `<span class="productPrice__current">${formatted}</span>`;
        if (variant.compare_at_price > variant.price) {
          const formattedCompareAt = window.Shopify.formatMoney(variant.compare_at_price, productForm.dataset.moneyFormat);
          priceHtml += `<s class="compareAtPrice">${formattedCompareAt}</s>`;
        }
        productPriceEl.innerHTML = priceHtml;
      }
      if (addToCartPriceEl && !productRoot.querySelector('[data-supplement-atc]')) {
        addToCartPriceEl.textContent = formatted.replace(/<[^>]+>/g, '');
      }
    }

    function resolveVariant() {
      const selectedOptionValues = [];
      for (let position = 1; position <= optionsSize; position++) {
        const checkedInGroup = variantPicker.querySelector(`input[name="variant-option-${position}"]:checked`);
        selectedOptionValues.push(checkedInGroup ? checkedInGroup.dataset.variantName : null);
      }

      return productData.variants.find(variant =>
        selectedOptionValues.every((value, index) =>
          value === null || variant[`option${index + 1}`] === value
        )
      );
    }

    variantPicker.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        const groupName = radio.getAttribute('name');
        const optionPosition = radio.dataset.optionPosition;

        // Scope active state to the changed group only
        variantPicker.querySelectorAll(`input[name="${groupName}"]`).forEach(groupRadio => {
          groupRadio.closest('label').classList.remove('active', 'border-2', 'bg-[#f9f6f1]');
        });
        radio.closest('label').classList.add('active', 'border-2', 'bg-[#f9f6f1]');

        // Sync the theme's hidden single-option-selector for this option position
        const fakeSelect = document.querySelector(`.single-option-selector[data-option="option${optionPosition}"]`);
        if (fakeSelect) {
          fakeSelect.value = radio.dataset.variantName;
          fakeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Find the variant that satisfies all selected options and update the hidden select
        const matchedVariant = resolveVariant();
        if (matchedVariant) {
          variantSelect.value = matchedVariant.id;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          window.history.pushState({}, '', `?variant=${matchedVariant.id}`);
          updatePriceDisplays(matchedVariant);
        }
      });
    });

    // Set initial active state per group
    variantPicker.querySelectorAll('input[type="radio"]:checked').forEach(checkedRadio => {
      checkedRadio.closest('label').classList.add('active', 'border-2', 'bg-[#f9f6f1]');
    });

    // Show compare-at price for the initially selected variant, not just after a change
    const initialVariant = resolveVariant();
    if (initialVariant) updatePriceDisplays(initialVariant);
  }

  initStickyAddToCart();
});

function initStickyAddToCart() {
  const mainButton = document.querySelector('[data-supplement-atc]');
  const sticky = document.querySelector('[data-sticky-atc]');
  const stickyButton = sticky?.querySelector('[data-sticky-atc-button]');
  if (!mainButton || !sticky || !stickyButton || sticky.dataset.stickyAtcReady === 'true') return;
  sticky.dataset.stickyAtcReady = 'true';

  if (sticky.parentElement !== document.body) {
    document.body.appendChild(sticky);
  }

  const mainButtonStyle = getComputedStyle(mainButton);
  stickyButton.style.fontFamily = mainButtonStyle.fontFamily;
  stickyButton.style.fontSize = mainButtonStyle.fontSize;
  stickyButton.style.fontWeight = mainButtonStyle.fontWeight;
  stickyButton.style.letterSpacing = mainButtonStyle.letterSpacing;
  stickyButton.style.textTransform = mainButtonStyle.textTransform;

  const iconTemplate = mainButton.querySelector('.text svg')?.cloneNode(true) || null;
  const buttonsWrap = mainButton.closest('.purchase-details__buttons');
  let syncing = false;

  function expectedLabel() {
    return mainButton.getAttribute('data-atc-label') || 'Add to cart';
  }

  function readLabel(el) {
    if (!el) return '';
    const clone = el.cloneNode(true);
    clone.querySelectorAll('svg').forEach((node) => node.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function writeLabel(el, label) {
    el.textContent = '';
    if (iconTemplate) el.appendChild(iconTemplate.cloneNode(true));
    el.append(document.createTextNode(label));
  }

  function labelElement(button) {
    let textEl = button.querySelector('.text');
    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className = 'text flex items-center justify-center gap-2';
      textEl.style.display = 'flex';
      const check = button.querySelector('.checkmark');
      button.insertBefore(textEl, check);
    }
    return textEl;
  }

  function isUnavailable() {
    return mainButton.disabled
      || mainButton.classList.contains('disabled')
      || buttonsWrap?.classList.contains('product-is-unavailable');
  }

  function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const label = expectedLabel();
      [mainButton, stickyButton].forEach((button) => {
        const textEl = labelElement(button);
        if (readLabel(textEl) !== label) writeLabel(textEl, label);
      });

      const unavailable = isUnavailable();
      stickyButton.disabled = unavailable;
      stickyButton.classList.toggle('disabled', unavailable);
      stickyButton.classList.toggle('opacity-50', unavailable);
      stickyButton.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      if (buttonsWrap?.classList.contains('product-is-unavailable')) {
        if (mainButton.getAttribute('aria-disabled') !== 'true') {
          mainButton.setAttribute('aria-disabled', 'true');
        }
      } else if (!mainButton.disabled && mainButton.hasAttribute('aria-disabled')) {
        mainButton.removeAttribute('aria-disabled');
      }

      const mainCheck = mainButton.querySelector('.checkmark');
      const stickyCheck = stickyButton.querySelector('.checkmark');
      if (mainCheck && stickyCheck) {
        stickyCheck.classList.toggle('checkmark-active', mainCheck.classList.contains('checkmark-active'));
      }
    } finally {
      syncing = false;
    }
  }

  function getHeaderOffset() {
    const sources = [document.body, document.querySelector('.sticky_nav--stick')];
    for (const source of sources) {
      if (!source) continue;
      const value = parseFloat(getComputedStyle(source).getPropertyValue('--sticky-header-height'));
      if (!Number.isNaN(value) && value > 0) return Math.round(value);
    }

    const header = document.querySelector('.header-group.sticky #header, .sticky_nav--stick');
    if (!header) return 0;
    const position = getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;
    return Math.round(header.getBoundingClientRect().height);
  }

  function setStickyVisible(show) {
    if (!show && document.activeElement === stickyButton) {
      mainButton.focus({ preventScroll: true });
    }
    sticky.hidden = !show;
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function updateVisibility() {
    const rect = mainButton.getBoundingClientRect();
    setStickyVisible(rect.bottom <= getHeaderOffset());
  }

  mainButton.addEventListener('click', (event) => {
    if (!buttonsWrap?.classList.contains('product-is-unavailable')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  stickyButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (stickyButton.disabled || isUnavailable()) return;
    stickyButton.disabled = true;
    mainButton.click();
  });

  const observer = new MutationObserver(sync);
  observer.observe(mainButton, {
    attributes: true,
    attributeFilter: ['disabled', 'class', 'aria-disabled'],
    childList: true,
    characterData: true,
    subtree: true
  });
  if (buttonsWrap) {
    observer.observe(buttonsWrap, { attributes: true, attributeFilter: ['class'] });
  }

  let visibilityFrame = 0;
  window.addEventListener('scroll', () => {
    if (visibilityFrame) return;
    visibilityFrame = window.requestAnimationFrame(() => {
      visibilityFrame = 0;
      updateVisibility();
    });
  }, { passive: true });
  window.addEventListener('resize', updateVisibility);

  sync();
  updateVisibility();
}
